import React, { useContext, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faAddressCard, faLanguage, faE, faBus, faPen, faEye, faSync, faTimes, faBuildingCircleCheck, faCalendarWeek} from '@fortawesome/free-solid-svg-icons';
import CountUp from 'react-countup';
import { Card, Row, Col, OverlayTrigger, Tooltip, Button, Form } from "react-bootstrap";
import { CSSTransition } from 'react-transition-group';
import ChartsContext from "contexts/ChartsContext";
import TodayRegistration from "./DetailsTable/TodayRegistration";
import CheckinTable from "./DetailsTable/CheckinTable";
import Papa from 'papaparse';
import { useHistory } from 'react-router-dom';


function DataSnapshots({ onRefresh }) {
  const [showCheckinTable, setShowCheckinTable] = useState(false);
  const [showTotalToday, setShowTotalToday] = useState(false);

  const history = useHistory();

  const handleFullListDetailsClick = () => {
    history.push('/admin/eventregadmin');
  };
  const {
    updateTime,
    selectedEvent,
    setSelectedEvent,
    totalEntries,
    totalEntriesEvent1,
    totalEntriesEvent2,
    totalToday,
    totalTodayEvent1,
    totalTodayEvent2,
    checkIns,
    totalHeadCountEvent1,
    totalHeadCountEvent2,
    checkInGroupSizeTotalEvent1,
    checkInGroupSizeTotalEvent2
  } = useContext(ChartsContext);

  // Debug: Log context values to check if data is being propagated
  React.useEffect(() => {
    console.log("DataSnapshots - Context Values:", {
      totalEntriesEvent1,
      totalEntriesEvent2,
      totalTodayEvent1,
      totalTodayEvent2,
      totalHeadCountEvent1,
      totalHeadCountEvent2,
      checkInGroupSizeTotalEvent1,
      checkInGroupSizeTotalEvent2,
      totalToday
    });
  }, [totalEntriesEvent1, totalEntriesEvent2, totalTodayEvent1, totalTodayEvent2, totalHeadCountEvent1, totalHeadCountEvent2, checkInGroupSizeTotalEvent1, checkInGroupSizeTotalEvent2, totalToday]);

  // Function to handle PDF download (to be implemented)
  const handleCSVDownload = (data, filename) => {
    // Define the column order
    const columnOrder = [
      'id', 
      'firstname', 
      'lastname', 
      'chinesename', 
      'email', 
      'phone', 
      'checkedIn', 
      'lastNotificationSent', 
      'checkedInTime', 
      'registrationTime'
    ];
    

    // Use PapaParse to unparse the data with the specified columns
    const csv = Papa.unparse({
      fields: columnOrder,
      data: data.map(row => columnOrder.reduce((obj, key) => ({ ...obj, [key]: row[key] }), {}))
    }, {
      quotes: false, // Quote all fields
      quoteChar: '"',
      escapeChar: '"',
      delimiter: ",",
      header: true,
      newline: "\r\n",
      skipEmptyLines: false, // Skip empty lines
      columns: columnOrder // Ensure the columns are in the correct order
    });

    // Create a Blob from the CSV String with UTF-8 BOM to ensure proper display of Chinese characters
    const BOM = "\uFEFF";
    const csvBlob = new Blob([BOM + csv], { type: 'text/csv;charset=utf-8;' });

    // Create a link and trigger the download
    const csvUrl = URL.createObjectURL(csvBlob);
    const downloadLink = document.createElement('a');
    downloadLink.href = csvUrl;
    downloadLink.setAttribute('download', `${filename}.csv`);
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };


  // Function to handle closing (to be implemented)
  const handleTableClose = (table) => {
    if (table === 'checkin') {
      setShowCheckinTable(false);
    }
    else if (table === 'totalToday') {
      setShowTotalToday(false);
    }
  };

  const handleDetailsButtonClick = (table) => {
    setShowCheckinTable(table === 'checkin');
    setShowTotalToday(table === 'totalToday');
  };

  // Helper function to get event-specific values
  const getEventData = () => {
    if (selectedEvent === 'event1') {
      return {
        label: '歲末祈福法會',
        totalEntries: totalEntriesEvent1 || 0,
        totalToday: totalTodayEvent1 || 0,
        totalHeadCount: totalHeadCountEvent1 || 0,
        checkInGroupSizeTotal: checkInGroupSizeTotalEvent1 || 0,
        iconLabel: '報名',
        checkInLabel: '簽到',
        participantsLabel: '預計到場'
      };
    } else {
      return {
        label: '新春合禮團拜會',
        totalEntries: totalEntriesEvent2 || 0,
        totalToday: totalTodayEvent2 || 0,
        totalHeadCount: totalHeadCountEvent2 || 0,
        checkInGroupSizeTotal: checkInGroupSizeTotalEvent2 || 0,
        iconLabel: '報名',
        checkInLabel: '簽到',
        participantsLabel: '預計到場'
      };
    }
  };

  const eventData = getEventData();

  return (
    <div style={{ width: '100%' }}>
      {/* Toggle Switch Row */}
      <Row className="mb-3">
        <Col md="12" className="d-flex justify-content-center align-items-center">
          <div className="d-flex align-items-center justify-content-center mb-2">
            <label className="mb-0">
              <span className={`mr-2 mb-0 ${selectedEvent === 'event1' ? "text-warning font-weight-bold" : ""}`}>
                歲末祈福法會
              </span>
            </label>
            <Form.Check
              type="switch"
              id="event-toggle"
              checked={selectedEvent === 'event2'}
              onChange={(e) => setSelectedEvent(e.target.checked ? 'event2' : 'event1')}
            />
            <label className="mb-0">
              <span className={`ml-2 ${selectedEvent === 'event2' ? "text-warning font-weight-bold" : ""}`}>
                新春合禮團拜會
              </span>
            </label>
          </div>
        </Col>
      </Row>

      <Row>
        {/* Total Registrations Card */}
        <Col lg="4" sm="6">
          <div className="card-container">
            <Card className="card-stats">
              <Card.Body>
                <Row>
                  <Col xs="5">
                    <div className="icon-big text-center icon-warning">
                      <span className="text-info">{eventData.iconLabel}</span>
                    </div>
                  </Col>
                  <Col xs="7">
                    <div className="numbers">
                      <p className="card-category font-weight-bold"><span className="text-warning">{eventData.label}</span>總報名人數</p>
                      <Card.Title as="h2" className="font-weight-bold text-dark">
                        <CountUp end={eventData.totalEntries} duration={2.75} />
                        <span className="h6"> 人</span>
                      </Card.Title>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer>
                <hr />
                <div className="stats">
                  <i className="fas fa-redo mr-1"></i>
                  Updated at <span className="font-weight-bold">{updateTime}</span>
                </div>
              </Card.Footer>
            </Card>
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top1">Details</Tooltip>}>
              <Button className="btn-round btn-outline details-button" variant="twitter" onClick={handleFullListDetailsClick}>
                <FontAwesomeIcon icon={faEye} />
              </Button>
            </OverlayTrigger>
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top2">Refresh</Tooltip>}>
              <Button className="btn-round btn-outline refresh-button" variant="warning" onClick={onRefresh}>
                <FontAwesomeIcon icon={faSync} />
              </Button>
            </OverlayTrigger>
          </div>
        </Col>

        {/* Today's registration Card */}
        <Col lg="4" sm="6">
          <div className="card-container">
            <Card className="card-stats">
              <Card.Body>
                <Row>
                  <Col xs="5">
                    <div className="icon-big text-center icon-warning">
                      <span className="text-success">今日</span>
                    </div>
                  </Col>
                  <Col xs="7">
                    <div className="numbers">
                      <p className="card-category font-weight-bold">{eventData.label}<span className="text-warning">今日</span>報名人數</p>
                      <Card.Title as="h2" className="font-weight-bold text-dark">
                        <CountUp end={eventData.totalToday} duration={2.75} />
                        <span className="h6"> 人</span>
                      </Card.Title>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer>
                <hr />
                <div className="stats">
                  <i className="fas fa-redo mr-1"></i>
                  Updated at <span className="font-weight-bold">{updateTime}</span>
                </div>
              </Card.Footer>
            </Card>
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top1">Details</Tooltip>}>
              <Button className="btn-round btn-outline details-button" variant="twitter" onClick={() => handleDetailsButtonClick('totalToday')}>
                <FontAwesomeIcon icon={faEye} />
              </Button>
            </OverlayTrigger>
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top2">Refresh</Tooltip>}>
              <Button className="btn-round btn-outline refresh-button" variant="warning" onClick={onRefresh}>
                <FontAwesomeIcon icon={faSync} />
              </Button>
            </OverlayTrigger>
          </div>
        </Col>

        {/* Check-in Card */}
        <Col lg="4" sm="6">
          <div className="card-container">
            <Card className="card-stats">
              <Card.Body>
                <Row>
                  <Col xs="5">
                    <div className="icon-big text-center icon-warning">
                      <span className="text-body">{eventData.checkInLabel}</span>
                    </div>
                  </Col>
                  <Col xs="7">
                    <div className="numbers">
                      <p className="card-category font-weight-bold">{eventData.label}<span className="text-warning">{eventData.checkInLabel}</span>總人數</p>
                      <Card.Title as="h2" className="font-weight-bold text-dark">
                        <CountUp end={eventData.checkInGroupSizeTotal} duration={2.75} />
                        <span className="h6"> 人</span>
                      </Card.Title>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer>
                <hr />
                <div className="stats">
                  <i className="fas fa-redo mr-1"></i>
                  Updated at <span className="font-weight-bold">{updateTime}</span>
                </div>
              </Card.Footer>
            </Card>
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top1">Details</Tooltip>}>
              <Button className="btn-round btn-outline details-button" variant="twitter" onClick={() => handleDetailsButtonClick('checkin')}>
                <FontAwesomeIcon icon={faEye} />
              </Button>
            </OverlayTrigger>
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top2">Refresh</Tooltip>}>
              <Button className="btn-round btn-outline refresh-button" variant="warning" onClick={onRefresh}>
                <FontAwesomeIcon icon={faSync} />
              </Button>
            </OverlayTrigger>
          </div>
        </Col>
      </Row>

      <Row>
        {/* Total Participants Card */}
        <Col lg="8" sm="6">
          <div className="card-container">
            <Card className="card-stats">
              <Card.Body>
                <Row>
                  <Col xs="5">
                    <div className="icon-big text-center icon-warning">
                      <span className="text-danger">{eventData.participantsLabel}</span>
                    </div>
                  </Col>
                  <Col xs="7">
                    <div className="numbers">
                      <p className="card-category font-weight-bold">{eventData.label}<span className="text-danger">{eventData.participantsLabel}</span>總人數</p>
                      <Card.Title as="h2" className="font-weight-bold text-dark">
                        <CountUp end={eventData.totalHeadCount} duration={2.75} />
                        <span className="h6"> 人</span>
                      </Card.Title>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer>
                <hr />
                <div className="stats">
                  <i className="fas fa-redo mr-1"></i>
                  Updated at <span className="font-weight-bold">{updateTime}</span>
                </div>
              </Card.Footer>
            </Card>
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top2">Refresh</Tooltip>}>
              <Button className="btn-round btn-outline refresh-button" variant="warning" onClick={onRefresh}>
                <FontAwesomeIcon icon={faSync} />
              </Button>
            </OverlayTrigger>
          </div>
        </Col>
      </Row>



      <CSSTransition in={showCheckinTable} timeout={300} classNames="table-transition" unmountOnExit>
        <Row>
          <Col md="12">
            <CheckinTable handleCSVDownload={handleCSVDownload} handleTableClose={() => handleTableClose('checkin')} />
          </Col>
        </Row>
      </CSSTransition>

      <CSSTransition in={showTotalToday} timeout={300} classNames="table-transition" unmountOnExit>
        <Row>
          <Col md="12">
            <TodayRegistration handleCSVDownload={handleCSVDownload} handleTableClose={() => handleTableClose('totalToday')} />
          </Col>
        </Row>
      </CSSTransition>
    </div>
  );
}

export default DataSnapshots;
